<template>
  <div>
    <!-- Tabla -->
    <div class="mt-2 hidden lg:block">
      <div
        class="min-w-full overflow-hidden overflow-x-auto align-middle shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg"
      >
        <table class="min-w-full divide-y divide-gray-200">
          <thead>
            <tr>
              <th
                class="bg-gray-50 px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500"
              >
                <span class="whitespace-nowrap">Nro. comprobante</span> (delegación)
              </th>

              <th
                class="bg-gray-50 px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500"
              >
                Datos titular
              </th>

              <th
                class="bg-gray-50 px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500"
              >
                Factura asociada
              </th>

              <th
                class="bg-gray-50 px-6 py-3 text-right text-xs font-medium uppercase tracking-wider text-gray-500"
              >
                Monto
              </th>

              <th
                class="bg-gray-50 px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500"
              >
                Fechas
              </th>

              <!-- <th
                class="px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase bg-gray-50"
              >
                Vencimiento
              </th> -->

              <th
                class="bg-gray-50 px-6 py-3 text-center text-xs font-medium uppercase tracking-wider text-gray-500"
              >
                Acciones
              </th>
            </tr>
          </thead>

          <tbody class="divide-y divide-gray-200 bg-white">
            <tr
              v-for="(comprobanteTerceros, index) in comprobantesTerceros"
              :key="index"
              class="bg-white"
            >
              <td class="whitespace-nowrap px-6 py-4 text-left text-sm text-gray-500">
                <div>{{ comprobanteTerceros.comprobante.numero_comprobante.trim() }}</div>
                <div>({{ comprobanteTerceros.sede.descripcion }})</div>
              </td>

              <td class="px-6 py-4 text-left text-sm text-gray-500">
                <p class="whitespace-nowrap">
                  <span class="font-medium">Apellido y nombre:</span>
                  {{ comprobanteTerceros.apellido }}, {{ comprobanteTerceros.nombres }}
                </p>
                <p>
                  <span class="font-medium">CUIT/CUIL:</span>
                  {{ comprobanteTerceros.cuit_cuil | cuit }}
                </p>
                <p class="whitespace-nowrap">
                  <span class="font-medium">E-mail:</span>
                  {{ comprobanteTerceros.email }}
                </p>
                <p>
                  <span class="font-medium">Teléfono:</span>
                  {{ comprobanteTerceros.telefono }}
                </p>
              </td>

              <td class="whitespace-nowrap px-6 py-4 text-left text-sm text-gray-500">
                {{ factura(comprobanteTerceros) }}
              </td>

              <td class="whitespace-nowrap px-6 py-4 text-right text-sm text-gray-500">
                {{ comprobanteTerceros.comprobante.monto | currency }}
              </td>

              <td class="px-6 py-4 text-left text-sm text-gray-500">
                <div class="font-medium">Creación:</div>
                <div class="whitespace-nowrap">
                  {{
                    getMomentDate(comprobanteTerceros.comprobante.fecha_carga)
                      | date('America/Buenos_Aires', 'DD-MM-Y')
                  }}
                </div>
                <div class="font-medium">Vencimiento:</div>
                <div class="whitespace-nowrap">
                  {{
                    getMomentDate(comprobanteTerceros.comprobante.fecha_vencimiento)
                      | date('America/Buenos_Aires', 'DD-MM-Y')
                  }}
                </div>
              </td>

              <!-- <td class="px-6 py-4 text-sm text-left text-gray-500 whitespace-nowrap">
                {{ getMomentDate(comprobanteTerceros.comprobante.fecha_vencimiento) | date('America/Buenos_Aires', 'DD-MM-Y') }}
              </td> -->

              <td class="whitespace-nowrap px-6 py-4 text-center text-sm">
                <button
                  v-if="accionMarcarMoroso(comprobanteTerceros)"
                  @click="
                    selectedComprobante = comprobanteTerceros
                    showConfirmModal = true
                  "
                  title='Marcar como "MOROSO"'
                  class="rounded-full bg-white p-1 text-amber-500"
                >
                  <BoxIconCalendarExclamation class="h-6 w-6 fill-current" />
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Cards -->
    <div class="grid grid-cols-1 justify-center gap-6 md:grid-cols-2 lg:hidden">
      <div
        v-for="(comprobanteTerceros, index) in comprobantesTerceros"
        :key="index"
        class="flex flex-col items-center justify-between gap-4 rounded-lg border-2 border-gray-200 bg-white p-4"
      >
        <div>
          <p class="text-base font-bold tracking-wide text-gray-600">
            Nro. comprobante: {{ comprobanteTerceros.comprobante.numero_comprobante }}
          </p>
        </div>

        <div class="text-center">
          <div class="pt-2 font-semibold text-gray-600">Datos del titular</div>

          <div>
            <p class="text-base font-medium text-gray-600">
              Apellido y nombre: {{ comprobanteTerceros.apellido }},
              {{ comprobanteTerceros.nombres }}
            </p>
          </div>

          <div>
            <p class="text-base font-medium text-gray-600">
              CUIT/CUIL: {{ comprobanteTerceros.cuit_cuil | cuit }}
            </p>
          </div>

          <div>
            <p class="text-base font-medium text-gray-600">
              E-mail: {{ comprobanteTerceros.email }}
            </p>
          </div>

          <div>
            <p class="text-base font-medium text-gray-600">
              Teléfono: {{ comprobanteTerceros.telefono }}
            </p>
          </div>

          <div class="pt-2 font-semibold text-gray-600">Datos del comprobante</div>

          <div>
            <p class="text-base font-medium text-gray-600">
              Delegación: {{ comprobanteTerceros.sede.descripcion }}
            </p>
          </div>

          <div>
            <p class="text-base font-medium text-gray-600">
              Factura de América asociada:
              <span class="whitespace-nowrap">{{ factura(comprobanteTerceros) }}</span>
            </p>
          </div>

          <div>
            <p class="text-base font-medium text-gray-600">
              Monto: {{ comprobanteTerceros.comprobante.monto | currency }}
            </p>
          </div>

          <div>
            <p class="text-base font-medium text-gray-600">
              Fecha de creación:
              {{
                getMomentDate(comprobanteTerceros.comprobante.fecha_carga)
                  | date('America/Buenos_Aires', 'DD-MM-Y')
              }}
            </p>
          </div>

          <div>
            <p class="text-base font-medium text-gray-600">
              Vencimiento:
              {{
                getMomentDate(comprobanteTerceros.comprobante.fecha_vencimiento)
                  | date('America/Buenos_Aires', 'DD-MM-Y')
              }}
            </p>
          </div>
        </div>
        <div class="space-y-2 sm:space-x-2 sm:space-y-0">
          <button
            v-if="accionMarcarMoroso(comprobanteTerceros)"
            @click="
              selectedComprobante = comprobanteTerceros
              showConfirmModal = true
            "
            class="focus:shadow-outline inline-flex w-full items-center justify-center space-x-2 rounded-md border border-gray-300 bg-white px-4 py-3 text-base font-medium text-gray-700 shadow-sm transition duration-150 ease-in-out hover:bg-cool-gray-200 focus:border-blue-300 focus:outline-none sm:w-max"
          >
            <BoxIconCalendarExclamation class="h-5 w-5 fill-current" />
            <span>Marcar como "MOROSO"</span>
          </button>
        </div>
      </div>
    </div>

    <!-- ConfirmationModal -->
    <ConfirmationModal
      :isOpen="showConfirmModal"
      @save="marcarComoMoroso"
      @modal:cancel="
        showConfirmModal = false
        observaciones = null
      "
    >
      <template #default>
        <span v-if="selectedComprobante">
          El comprobante {{ selectedComprobante.comprobante.numero_comprobante }} será marcado como
          "MOROSO".
        </span>
      </template>
      <template #after-confirm>
        <div class="space-y-2 md:flex md:items-center md:space-x-6 md:space-y-0">
          <label for="observaciones" class="w-44 text-sm font-medium tracking-wide text-gray-700">
            <span>Observaciones</span>
          </label>
          <div class="w-full max-w-xl sm:w-5/6">
            <textarea
              v-model="observaciones"
              id="observaciones"
              maxlength="255"
              class="block w-full rounded-md shadow-sm transition duration-200 ease-in-out sm:text-sm"
            />
          </div>
        </div>
      </template>
    </ConfirmationModal>
  </div>
</template>

<script>
import { useService } from '@colescba/app-vue'
import { useSession, useAcreditacionServicio } from '@colescba/ui'

import moment from 'moment'
import ConfirmationModal from '@/components/Core/ConfirmationModal'

export default {
  props: ['comprobantesTerceros'],

  components: { ConfirmationModal },

  mixins: [useService('portalPagos'), useSession(), useAcreditacionServicio()],

  data() {
    return {
      showConfirmModal: false,
      selectedComprobante: null,
      observaciones: null,
    }
  },

  methods: {
    factura(comprobanteTerceros) {
      return comprobanteTerceros.uso.factura_codigo
        ? `${comprobanteTerceros.uso.factura_codigo.trim().toUpperCase()} ${
            comprobanteTerceros.uso.factura_numero
          }`
        : ''
    },
    async marcarComoMoroso(done) {
      try {
        await this.portalPagos.patchPagoPorComprobante(
          this.user.cuitCuil.numero,
          this.selectedComprobante.comprobante.numero_comprobante,
          {
            pago_id: 'MOROSO',
            observaciones: this.observaciones,
          }
        )

        done()

        this.$toast.open({
          message: 'Se marcó como moroso el comprobante.',
          type: 'success',
          duration: 2500,
          dismissible: true,
        })

        this.showConfirmModal = false
        this.$emit('refresh')
      } catch (e) {
        console.log(e)
        done('Ocurrió un error al procesar la información.')
      }
    },

    getMomentDate(date) {
      return moment(date, 'DD-MM-YYYY')
    },

    accionMarcarMoroso(comprobanteTerceros) {
      return (
        this.userHasAnyRole(['AGENTETESORERIA']) &&
        comprobanteTerceros.uso.estado_id == 'USADO' &&
        comprobanteTerceros.pago.estado_id == 'A_VERIFICAR'
      )
    },
  },
}
</script>
